import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

function Portal({ children }) {
  const [container] = useState(() => {
    const el = document.createElement('div');
    el.id = 'portal-root';
    return el;
  });

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  return ReactDOM.createPortal(children, container);
}

export default Portal;
